import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ImportOrderPageRoutingModule } from './import-order-validation-routing.module';
import { ImportOrderValidationPage } from './import-order-validation.page';
import { SharedModule } from '@shared/shared.module';
import { ImportOrderValidationProductComponent } from '../../components/import-order-validation/import-order-validation-product/import-order-validation-product.component';
import { TranslateModule } from '@ngx-translate/core';
import { EffectsModule } from '@ngrx/effects';
import { ImportOrderValidationTracingEffects } from './tracking/tracing/import-order-validation-tracing.effects';
import { ImportOrderValidationSplitProductComponent } from '@order/components/import-order-validation/import-order-validation-split-product/import-order-validation-split-product.component';
import { ImportOrderQuantityInputComponent } from '@order/components/import-order-validation/import-order-quantity-input/import-order-quantity-input.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImportOrderPageRoutingModule,
    SharedModule,
    TranslateModule,
    EffectsModule.forFeature([ImportOrderValidationTracingEffects]),
  ],
  declarations: [
    ImportOrderValidationPage,
    ImportOrderValidationProductComponent,
    ImportOrderValidationSplitProductComponent,
    ImportOrderQuantityInputComponent,
  ],
})
export class ImportOrderPageModule {}
